import BannerManagement from './BannerManagement'

export default BannerManagement
